import { ChangeDetectorRef, Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient } from '@delon/theme';
import { SelectBaseComponent } from 'src/app/shared-feature/components/select/select-base';

@Component({
  selector: 'app-stock-location-multi-select',
  templateUrl: './stock-location-multi-select.component.html',
  styles: [` :host ::ng-deep .ant-select-clear { right:40px !important; }
             :host ::ng-deep .ant-select-multiple.ant-select-allow-clear .ant-select-selector { padding-right: 50px!important;}
          `],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StockLocationMultiSelectComponent),
      multi: true
    }
  ]
})
export class StockLocationMultiSelectComponent extends SelectBaseComponent {
  constructor(http: _HttpClient, cdr: ChangeDetectorRef) {
    super(http, cdr);
  }

  get locationList() {
    return this.list.filter((o: any) => o.id);
  }

  getUrl(searchValue: string): string {
    let filter = `isActive eq true`;
    if (searchValue && searchValue.trim()) {
      const searchStr = searchValue.trim().replaceAll("'", "''");
      filter = `(${filter}) and (contains(code, '${encodeURIComponent(searchStr)}') or contains(name,'${encodeURIComponent(searchStr)}'))`;
    }
    return `api/stockLocations/lookup?$top=20&$skip=0&$orderby=code asc&$filter=${filter}`;
  }
}
